import axios from 'axios';
import { API_URL } from './constants';
export const GOOGLE_FLOW_KEY = 'devssoft-google-flow';
export const googleApi = axios.create({ baseURL: API_URL });
export const googleHeaders = () => ({ headers: { Authorization: 'Bearer ' + localStorage.getItem('token') } });
export function safeReturnTo(value) {
  return typeof value === 'string' && value.startsWith('/') && !value.startsWith('//') && !value.includes('\\') && !Array.from(value).some(character => character.charCodeAt(0) < 32) &&
    !value.startsWith('/auth/google/callback') && !value.startsWith('/login') ? value : '/apps';
}
export async function startGoogleFlow({ purpose = 'login', returnTo = '/apps' } = {}) {
  sessionStorage.removeItem(GOOGLE_FLOW_KEY);
  const { data } = await googleApi.post(purpose === 'link' ? '/auth/google/link/start' : '/auth/google/start', {}, purpose === 'link' ? googleHeaders() : undefined);
  const url = new URL(data.authorizationUrl);
  if (url.protocol !== 'https:' && !(url.protocol === 'http:' && ['localhost', '127.0.0.1'].includes(url.hostname))) throw new Error('No se pudo abrir la autenticación de Google.');
  const state = url.searchParams.get('state');
  if (!state || !data.browserProof) throw new Error('No se pudo iniciar la autenticación de Google.');
  sessionStorage.setItem(GOOGLE_FLOW_KEY, JSON.stringify({ state, browserProof: data.browserProof, purpose, returnTo: safeReturnTo(returnTo), startedAt: Date.now() }));
  window.location.assign(url.toString());
}
